import { PowerOffOutlined, PowerOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'

const PowersourceItem = ({ value }: { value: string }) => {
  const theme = useTheme()

  const { ariaLabel, iconColor, IconComponent } = {
    BATT: { ariaLabel: 'Battery powered', iconColor: theme.palette.error.main, IconComponent: PowerOffOutlined },
    LINE: { ariaLabel: 'Line powered', iconColor: theme.palette.success.main, IconComponent: PowerOutlined },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: () => <>-</> }

  return <IconComponent htmlColor={iconColor} aria-label={ariaLabel} />
}

export default PowersourceItem
